import AppRoute from "models/AppRoute"

const HelpRoute = new AppRoute({
    route: "/help",
    navbar: true,
    authRequired: true,
})

export default HelpRoute
